var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 170",
    style: {
      enableBackground: "new 0 0 360 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#008C96;}\r\n\t.st1{fill:#004CAC;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 281.14,
    cy: 129.94,
    r: 6.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 187.13,
    cy: 64.69,
    r: 7.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 82.25,
    cy: 122.63,
    r: 7.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 149.65,
    cy: 102.7,
    r: 7.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 122.93,
    cy: 112.09,
    r: 7.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 100.53,
    cy: 117.36,
    r: 5.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 241.16,
    cy: 59.25,
    r: 7.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 210.74,
    cy: 45.43,
    r: 10.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 248.28,
    cy: 85.36,
    r: 8.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 290.55,
    cy: 91.98,
    r: 5.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 261.48,
    cy: 119.73,
    r: 7.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 264.2,
    cy: 96.81,
    r: 5.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 167.53,
    cy: 82.31,
    r: 7.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 65.76,
    cy: 135.21,
    r: 5.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 230.61,
    cy: 45.43,
    r: 5.27
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.32,161.4l-2.06,5.24h-1.13l6.01-14.9h1.06l5.97,14.9h-1.13l-2.1-5.24H61.32z M67.59,160.5l-2.1-5.24 c-0.4-1-0.6-1.64-0.82-2.37h-0.04c-0.22,0.75-0.46,1.42-0.82,2.3l-2.12,5.31H67.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.76,150.81v13.27c0,0.86,0.02,1.7,0.09,2.56h-1l-0.07-2.21h-0.04c-0.62,1.33-2.08,2.48-4.29,2.48 c-2.98,0-5.11-2.39-5.11-5.33c-0.02-3.45,2.37-5.81,5.35-5.81c2.21,0,3.47,1.17,3.94,2.03h0.04v-6.99H82.76z M81.68,160.3 c0-0.31-0.04-0.73-0.13-1.04c-0.46-1.44-1.83-2.61-3.83-2.61c-2.52,0-4.29,1.92-4.29,4.8c0,2.39,1.39,4.58,4.27,4.58 c1.81,0,3.4-1.24,3.85-2.92c0.09-0.29,0.13-0.57,0.13-0.93V160.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.72,164.08c0,0.86,0.02,1.7,0.09,2.56h-1.02l-0.07-2.14h-0.04c-0.64,1.17-1.99,2.41-4.13,2.41 c-1.22,0-4-0.42-4-4.93v-5.95h1.08v5.73c0,2.48,0.86,4.2,3.21,4.2c1.61,0,2.96-1.02,3.54-2.25c0.13-0.33,0.27-0.77,0.27-1.24 v-6.43h1.08V164.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.61,150.81h1.08v15.83h-1.08V150.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.11,152.87v3.16h3.36v0.86h-3.36v6.79c0,1.3,0.4,2.3,1.7,2.3c0.64,0,1.08-0.09,1.39-0.2l0.13,0.84 c-0.38,0.15-0.93,0.29-1.64,0.29c-0.84,0-1.53-0.27-1.97-0.8c-0.53-0.6-0.71-1.57-0.71-2.56v-6.66h-1.95v-0.86h1.95v-2.83 L106.11,152.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.01,151.93c0.99-0.17,2.34-0.31,4.17-0.31c1.99,0,3.44,0.42,4.39,1.22c0.89,0.73,1.46,1.9,1.46,3.3 c0,1.41-0.44,2.58-1.27,3.38c-1.1,1.08-2.78,1.6-4.71,1.6c-0.51,0-0.97-0.03-1.33-0.1v5.62h-2.7V151.93z M119.71,158.88 c0.35,0.09,0.78,0.12,1.33,0.12c2.03,0,3.28-1.01,3.28-2.76c0-1.64-1.15-2.52-3.03-2.52c-0.75,0-1.29,0.07-1.58,0.13V158.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.01,159.34c0-1.44-0.03-2.5-0.09-3.46h2.36l0.1,2.05h0.08c0.53-1.52,1.79-2.29,2.95-2.29 c0.27,0,0.42,0.01,0.64,0.06v2.56c-0.23-0.05-0.47-0.08-0.8-0.08c-1.3,0-2.2,0.83-2.44,2.06c-0.05,0.24-0.07,0.53-0.07,0.82v5.58 h-2.72V159.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.91,161.16c0,3.96-2.78,5.73-5.53,5.73c-3.04,0-5.39-2.1-5.39-5.55c0-3.53,2.33-5.7,5.57-5.7 C144.77,155.64,146.91,157.89,146.91,161.16z M138.79,161.27c0,2.07,1.03,3.64,2.68,3.64c1.56,0,2.64-1.51,2.64-3.67 c0-1.69-0.75-3.62-2.63-3.62C139.57,157.61,138.79,159.48,138.79,161.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.27,152.8v3.08h2.59v2.03h-2.59v4.75c0,1.32,0.35,1.99,1.39,1.99c0.47,0,0.81-0.05,1.06-0.12l0.05,2.07 c-0.41,0.15-1.12,0.28-1.98,0.28c-1,0-1.83-0.34-2.34-0.89c-0.58-0.62-0.85-1.61-0.85-3.02v-5.06h-1.54v-2.03h1.54v-2.44 L152.27,152.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.7,162.02c0.07,1.95,1.58,2.8,3.32,2.8c1.25,0,2.15-0.2,2.97-0.5l0.4,1.87 c-0.92,0.39-2.2,0.68-3.76,0.68c-3.5,0-5.54-2.16-5.54-5.46c0-2.97,1.8-5.78,5.26-5.78c3.5,0,4.64,2.88,4.64,5.23 c0,0.51-0.04,0.91-0.1,1.14H158.7z M163.43,160.12c0.01-1-0.42-2.62-2.24-2.62c-1.68,0-2.37,1.52-2.49,2.62H163.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.09,166.32c-0.56,0.27-1.69,0.56-3.04,0.56c-3.37,0-5.55-2.16-5.55-5.5c0-3.22,2.2-5.73,5.99-5.73 c1.01,0,2.01,0.22,2.63,0.49l-0.48,2.05c-0.44-0.21-1.09-0.42-2.06-0.42c-2.08,0-3.31,1.52-3.3,3.49c0,2.21,1.45,3.47,3.31,3.47 c0.93,0,1.61-0.2,2.14-0.42L176.09,166.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.57,152.8v3.08h2.59v2.03h-2.59v4.75c0,1.32,0.35,1.99,1.39,1.99c0.47,0,0.81-0.05,1.06-0.12l0.06,2.07 c-0.41,0.15-1.12,0.28-1.98,0.28c-1,0-1.83-0.34-2.34-0.89c-0.58-0.62-0.85-1.61-0.85-3.02v-5.06h-1.54v-2.03h1.54v-2.44 L181.57,152.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.1,152.87c0,0.81-0.59,1.47-1.55,1.47c-0.9,0-1.5-0.66-1.49-1.47c0-0.83,0.61-1.47,1.52-1.47 C188.5,151.4,189.09,152.03,189.1,152.87z M186.22,166.64v-10.76h2.72v10.76H186.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.59,155.88l1.74,5.47c0.31,0.95,0.54,1.81,0.74,2.69h0.07c0.2-0.89,0.44-1.74,0.73-2.69l1.71-5.47h2.86 l-4.11,10.76h-2.68l-4-10.76H193.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.74,162.02c0.07,1.95,1.58,2.8,3.32,2.8c1.25,0,2.15-0.2,2.97-0.5l0.4,1.87 c-0.92,0.39-2.2,0.68-3.76,0.68c-3.5,0-5.54-2.16-5.54-5.46c0-2.97,1.8-5.78,5.26-5.78c3.5,0,4.64,2.88,4.64,5.23 c0,0.51-0.04,0.91-0.1,1.14H204.74z M209.47,160.12c0.01-1-0.42-2.62-2.25-2.62c-1.67,0-2.37,1.52-2.49,2.62H209.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.85,163.68c0.88,0.51,2.21,0.95,3.6,0.95c1.74,0,2.71-0.82,2.71-2.03c0-1.12-0.75-1.79-2.64-2.47 c-2.46-0.87-4.03-2.19-4.03-4.33c0-2.44,2.04-4.28,5.27-4.28c1.62,0,2.8,0.34,3.57,0.74l-0.65,2.2 c-0.54-0.28-1.58-0.71-2.98-0.71c-1.73,0-2.46,0.92-2.46,1.8c0,1.14,0.86,1.68,2.85,2.44c2.59,0.99,3.83,2.29,3.83,4.43 c0,2.4-1.81,4.48-5.65,4.48c-1.58,0-3.21-0.45-4.03-0.95L218.85,163.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.33,162.02c0.07,1.95,1.58,2.8,3.32,2.8c1.25,0,2.15-0.2,2.97-0.5l0.4,1.87 c-0.92,0.39-2.2,0.68-3.76,0.68c-3.5,0-5.54-2.16-5.54-5.46c0-2.97,1.8-5.78,5.26-5.78c3.5,0,4.64,2.88,4.64,5.23 c0,0.51-0.04,0.91-0.1,1.14H232.33z M237.07,160.12c0.01-1-0.42-2.62-2.25-2.62c-1.67,0-2.37,1.52-2.49,2.62H237.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.83,159.34c0-1.44-0.03-2.5-0.09-3.46h2.36l0.1,2.05h0.08c0.53-1.52,1.79-2.29,2.95-2.29 c0.27,0,0.42,0.01,0.64,0.06v2.56c-0.23-0.05-0.47-0.08-0.8-0.08c-1.3,0-2.2,0.83-2.44,2.06c-0.05,0.24-0.07,0.53-0.07,0.82v5.58 h-2.72V159.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.9,155.88l1.74,5.47c0.31,0.95,0.54,1.81,0.74,2.69h0.07c0.2-0.89,0.44-1.74,0.73-2.69l1.71-5.47h2.86 l-4.11,10.76h-2.68l-4-10.76H251.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,152.87c0,0.81-0.59,1.47-1.55,1.47c-0.9,0-1.5-0.66-1.49-1.47c0-0.83,0.61-1.47,1.52-1.47 C263.71,151.4,264.29,152.03,264.3,152.87z M261.42,166.64v-10.76h2.72v10.76H261.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.98,166.32c-0.56,0.27-1.69,0.56-3.04,0.56c-3.38,0-5.55-2.16-5.55-5.5c0-3.22,2.2-5.73,5.99-5.73 c1.01,0,2.01,0.22,2.63,0.49l-0.48,2.05c-0.44-0.21-1.09-0.42-2.06-0.42c-2.08,0-3.31,1.52-3.3,3.49c0,2.21,1.45,3.47,3.3,3.47 c0.93,0,1.61-0.2,2.14-0.42L274.98,166.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.73,162.02c0.07,1.95,1.58,2.8,3.32,2.8c1.25,0,2.15-0.2,2.97-0.5l0.4,1.87 c-0.92,0.39-2.2,0.68-3.76,0.68c-3.5,0-5.54-2.16-5.54-5.46c0-2.97,1.8-5.78,5.26-5.78c3.5,0,4.64,2.88,4.64,5.23 c0,0.51-0.04,0.91-0.1,1.14H278.73z M283.46,160.12c0.01-1-0.42-2.62-2.25-2.62c-1.67,0-2.37,1.52-2.49,2.62H283.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.09,164.14c0.6,0.37,1.77,0.79,2.75,0.79c1.2,0,1.73-0.5,1.73-1.21c0-0.73-0.44-1.1-1.77-1.57 c-2.11-0.72-2.99-1.87-2.98-3.14c0-1.89,1.57-3.37,4.08-3.37c1.19,0,2.22,0.3,2.85,0.64l-0.54,1.91 c-0.45-0.26-1.32-0.62-2.28-0.62c-0.97,0-1.51,0.48-1.51,1.14c0,0.68,0.52,1.01,1.88,1.51c1.96,0.69,2.86,1.69,2.87,3.28 c0,1.96-1.53,3.38-4.37,3.38c-1.3,0-2.49-0.31-3.28-0.75L288.09,164.14z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAps);
export default __webpack_public_path__ + "static/media/APS.22272cfb5d6e70470ad28271aad33a7b.svg";
export { ForwardRef as ReactComponent };